import { atom } from 'jotai';
import { atomWithHash } from 'jotai-location';

import { Variant, type LoadWidgetProps } from '@automation-suite/widget-client/lib/package';

import { editorValueAtom } from './editorValueAtom';

type WidgetParams<V extends Variant = Variant> = LoadWidgetProps<V> & {
  variant: V;
};

export const widgetParamsHashAtom = atomWithHash<WidgetParams | undefined>('si-wid-hos-widget-props', {
  id: '',
  variant: Variant.FLOATING_ACTION_CARD,
});

export const widgetParamsAtom = atom(
  (get) => get(widgetParamsHashAtom),
  (_get, set, value: WidgetParams | undefined) => {
    set(widgetParamsHashAtom, value);
    set(editorValueAtom, JSON.stringify(value, null, '  '));
  }
);
